var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5341 0H2.46593C1.10403 0 0 1.10403 0 2.46593V29.5341C0 30.896 1.10403 32 2.46593 32H29.5341C30.896 32 32 30.896 32 29.5341V2.46593C32 1.10403 30.896 0 29.5341 0Z",
    fill: "#0EAF9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1469 21.3058C24.1469 21.4934 23.994 21.6447 23.8057 21.6447C22.1084 21.6447 20.7326 20.2777 20.7326 18.5913V13.1026C20.7326 10.6667 18.7451 8.69255 16.2941 8.69255C13.8432 8.69255 11.9648 10.6674 11.9648 13.1026V15.1358C11.9609 15.3197 12.108 15.4716 12.2922 15.4749C12.2949 15.4749 12.2969 15.4749 12.2995 15.4749H14.2387C14.4269 15.4787 14.5831 15.33 14.587 15.1424C14.587 15.1398 14.587 15.1378 14.587 15.1352V13.0201C14.587 12.083 15.351 11.3239 16.2941 11.3239C17.2373 11.3239 18.0013 12.083 18.0013 13.0201V25.7697C17.9974 25.9606 17.8385 26.1126 17.6464 26.1086C15.9569 26.1086 14.587 24.7475 14.587 23.0689C14.587 23.0643 14.587 23.0597 14.587 23.0552V18.9842C14.5831 18.7958 14.4281 18.6451 14.2387 18.6451H12.2995C12.1145 18.6451 11.9648 18.7939 11.9648 18.9776C11.9648 18.9802 11.9648 18.9822 11.9648 18.9848V20.342C11.9648 22.0285 10.4799 23.3955 8.78252 23.3955C8.59366 23.3955 8.44141 23.2436 8.44141 23.0565V13.1033C8.44141 8.79386 11.957 5.30078 16.2941 5.30078C20.6313 5.30078 24.1469 8.79386 24.1469 13.1033V21.3058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.38cb92e941f20cee2ef863d752fefcbd.svg";
export { ForwardRef as ReactComponent };